import React, { useRef } from 'react';
import ExcludeRatingInputCell from '@/common/form/ExcludeRatingInputCell'; // Adjust the import path according to your project

function IgnoreAnswerModal({ answer, handleCancel, handleConfirm }) {
    const excludeRatingCommentRef = useRef(answer?.ignoredComment || '');

    const onClickIgnore = () => {
        handleConfirm(excludeRatingCommentRef.current.value);
    };

    return (
        <div>
            <div className="alertBody">
                <div className="alertTitle" style={{ textAlign: 'left', marginBottom: '5px' }}>
                    Exclude Rating
                </div>
                <div style={{ color: 'white', marginBottom: '10px' }}>
                    Please provide a reason for excluding this rating:
                </div>
                <div className="alertMessage" style={{ textAlign: 'left' }}>
                    <div className="tableCell titledSelectCell textarea">
                        <ExcludeRatingInputCell
                            inputRef={excludeRatingCommentRef}
                            defaultValue={answer?.ignoredComment || ''}
                        />
                    </div>
                </div>
            </div>
            <div className="alertActions dualActions">
                <div onClick={handleCancel} className="alertAction button action medium">
                    <div className="buttonTitle">Cancel</div>
                </div>
                <div onClick={onClickIgnore} className="alertAction button medium confirm">
                    <div className="buttonTitle">Exclude</div>
                </div>
            </div>
        </div>
    );
}

export default IgnoreAnswerModal;